import { cx } from '@emotion/css';
import { ReactNode } from 'react';

import BackButton from './BackButton';
import {
  badgeClassName,
  bottomSpacingClassName,
  contentHeaderClassName,
  headingClassName,
  rightHeaderClassName,
} from './styles';

interface Props {
  backTo?: string;
  badge?: ReactNode;
  rightHeader?: ReactNode;
  title: string;
}

const ContentHeader = ({ backTo, badge, rightHeader, title }: Props) => {
  return (
    <div
      className={cx(contentHeaderClassName, {
        [bottomSpacingClassName]: !!backTo || !!rightHeader,
      })}
    >
      {backTo && <BackButton to={backTo} />}
      <h2 className={headingClassName}>{title}</h2>
      <div className={badgeClassName}>{badge}</div>
      {rightHeader && <div className={rightHeaderClassName}>{rightHeader}</div>}
    </div>
  );
};

ContentHeader.displayName = 'ContentHeader';

export default ContentHeader;
